import { createFileRoute, Outlet } from '@tanstack/react-router'

import { RequireAuth } from '@/components/auth/RequireAuth'

/**
 * Rota-layout sem segmento de URL: tudo que fica sob `_auth/` exige sessão.
 *
 * A guarda mora aqui, e não em cada rota, para que esquecer de protegê-la deixe
 * de ser possível — a única forma de criar uma rota autenticada é colocá-la
 * dentro desta pasta.
 */
function AuthenticatedLayout() {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  )
}

export const Route = createFileRoute('/_auth')({ component: AuthenticatedLayout })
